import styled from 'styled-components';

export const SankeyContainer = styled.div<{
	height: number;
	width: string | number;
}>`
	width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
	height: ${({ height }) => height}px;
	background-color: ${({ theme }) => theme.colors.system.background.white};
	border-radius: ${({ theme }) => theme.shapeRadius.regular};
	overflow: hidden;

	.nivo-tooltip {
		background-color: ${({ theme }) => theme.colors.system.background.white};
		border: 1px solid ${({ theme }) => theme.colors.system.border.xStrong};
		border-radius: ${({ theme }) => theme.shapeRadius.small};
		box-shadow: ${({ theme }) => theme.shadows.elevation.medium};
		padding: ${({ theme }) => theme.spacing.small};
		font-family: ${({ theme }) => theme.fonts.family.default};
		font-size: ${({ theme }) => theme.fonts.sizes.small};
		color: ${({ theme }) => theme.colors.system.text.default};
	}

	text {
		font-family: ${({ theme }) => theme.fonts.family.default};
		font-size: ${({ theme }) => theme.fonts.sizes.xs};
		fill: ${({ theme }) => theme.colors.system.text.default};
	}
`;
